// Le immagini possono essere un percorso del server oppure un URL completo (es. bucket AWS).
export const mediaUrl = (path) =>
  /^https?:\/\//i.test(path) ? path : `${process.env.REACT_APP_BASE_URL}${path}`;
